import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ApplicationSecurityService } from 'src/modules/features/setting/components/application-security/services/application-security.service';
import { PermissionService } from '../../../services/permission.service';

@Component({
  selector: 'app-file-upload-setting-row',
  templateUrl: './file-upload-setting-row.component.html',
  styleUrls: ['./file-upload-setting-row.component.scss'],
})
export class FileUploadSettingRowComponent implements OnInit {
  @Input() file: any;
  @Output() viewLogDetails: EventEmitter<any> = new EventEmitter();
  @Output() editUnit: EventEmitter<any> = new EventEmitter();
  @Output() blacklistIPAddress: EventEmitter<any> = new EventEmitter();
  @Output() createAlert: EventEmitter<any> = new EventEmitter();
  pending: boolean;
  collapseEquipment: boolean = true;
  filter: any;
  units: any = [
    {
      fileType: 'image/png',
      maximumSize: '5000',
    },
  ];
  error: any;
  department: any = {};
  settings: any = [];
  constructor(
    private appSecuritySvc: ApplicationSecurityService,
    private permissionService: PermissionService,
    private modalService: SuiModalService
  ) {}

  ngOnInit(): void {}

  toggleEquipment() {
    this.collapseEquipment = !this.collapseEquipment;
    if (this.collapseEquipment == false) {
      this.jsonParser(this.file);
    }
  }
  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.appSecuritySvc
      .getAllFileManagementSettings({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.units = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  onViewUnit(unit) {}

  jsonParser(item: any) {
    if (!item.settings) return;
    let parsed = JSON.parse(item.settings);

    this.settings = Object.keys(parsed).map((key) => ({
      key: this.transformToReadableText(key.split('MaxSize')[0]),
      value: parsed[key],
      dateModified: item.dateModified,
      modifiedBy: item.modifiedBy,
    }));

    return this.settings;
  }

  transformToReadableText(str) {
    if (!str) return;
    // Step 1: Insert a space before each uppercase letter (except the first one)
    const formatted = str.replace(/([a-z])([A-Z])/g, '$1 $2');

    // Step 2: Capitalize the first letter of each word and lowercase the rest
    return formatted.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  checkPermission(event: { id: string; action: string }): boolean {
    console.log('I got here for file');
    const { id, action } = event;
    console.log(id, ': ', this.permissionService.checkPermission(id, action));
    return this.permissionService.checkPermission(id, action);
  }
}
